import { render, staticRenderFns } from "./duck.vue?vue&type=template&id=1e7edf40&scoped=true&"
import script from "./duck.vue?vue&type=script&lang=js&"
export * from "./duck.vue?vue&type=script&lang=js&"
import style0 from "./duck.vue?vue&type=style&index=0&id=1e7edf40&lang=scss&scoped=true&"
import style1 from "./duck.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7edf40",
  null
  
)

/* custom blocks */
import block0 from "./duck.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
